<template>
  <main-layout>
    <div class="buttons is-pulled-right">
      <router-link
        class="button is-success is-small"
        :to="{ name: 'customers.create' }"
      >
        Nuovo
      </router-link>
    </div>
    <h1 class="title">Clienti</h1>

    <api-table
      :fetch-action="fetch"
      :items-getter="getter"
      :has-provinces="true"
      :filters="[
        ['expiring_contracts', 'Contratti in scadenza'],
        ['sleaping_customer', 'Cliente inattivo'],
        ['lead', 'Lead'],
        ['legacy_products', 'Versioni obsolete'],
        ['prospects', 'Prospect'],
        ['customers', 'Clienti'],
        ['subresellers', 'Subrivenditori'],
        ['public_entities', 'Enti pubblici'],
        ['security_prospects', 'Prospect Security'],
        ['security_customers', 'Clienti Security']
      ]"
    >
      <template slot-scope="props">
        <b-table-column
          field="internal_id"
          label="ID"
          width="40"
          sortable
          numeric
        >
          <span class="is-family-code">{{ props.row.internal_id }}</span>
        </b-table-column>

        <b-table-column field="name" label="Nome" sortable>
          <b>
            <router-link
              :to="{ name: 'customers.show', params: { id: props.row.id } }"
            >
              {{ props.row.name }}
            </router-link>
          </b>
        </b-table-column>

        <b-table-column field="prospect" label="Tipo" sortable>
          {{ props.row.prospect_display }}
        </b-table-column>

        <b-table-column field="modified" label="Modificato" sortable centered>
          <b-tooltip
            :label="new Date(props.row.modified).toLocaleString('it-IT')"
            type="is-dark"
            position="is-right"
            animated
          >
            <span class="tag is-light">
              <timeago :datetime="props.row.modified" :auto-update="60" />
            </span>
          </b-tooltip>
        </b-table-column>

        <b-table-column label="Azioni" width="240">
          <div class="buttons">
            <router-link
              :to="{ name: 'customers.show', params: { id: props.row.id } }"
              class="button is-small is-info"
            >
              <span>Mostra</span>
            </router-link>
            <a class="button is-small" @click="generateEmail(props.row.id)">
              Fattura
            </a>
            <delete-button
              :id="props.row.id"
              :submit-action="destroy"
              @done="fetch()"
            />
          </div>
        </b-table-column>
      </template>
    </api-table>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"

import MainLayout from "@/layouts/Main"
import DeleteButton from "@/components/DeleteButton"
import CustomerProxy from "@/proxies/CustomerProxy"

export default {
  name: "CustomersIndex",
  components: {
    MainLayout,
    DeleteButton
  },
  data() {
    return {
      search: ""
    }
  },
  methods: {
    fetch: call("customers/all"),
    getter: get("customers/customers"),
    destroy: call("customers/destroy"),
    async generateEmail(id) {
      let customer = await new CustomerProxy().find(id)
      let body = `Buongiorno,

Avrei bisogno di questa fattura:

${customer.name}
${customer.legal_address}
${customer.legal_zip_code} ${customer.legal_town} (${customer.legal_province})
Partita IVA: ${customer.vat_id}
Codice Fiscale: ${customer.ssn_id}
Codice SDI: ${customer.sdi_code}
Mail PEC: ${customer.pec}

Causale:

Importo €

Pagamento: ${customer.payment_method_display}

Grazie
Cordiali saluti
      `
      let link = [
        `mailto:giuseppe.cocozza@gmail.com`,
        `?subject=${encodeURIComponent("Richiesta fattura")}`,
        `&body=${encodeURIComponent(body)}`
      ].join("")
      // console.log(link)
      window.location = link
    }
  }
}
</script>
